<template>
  <form @submit.prevent="verifyUserCode" class="card-panel">
    <p class="left-align">
      <b class="medium-text">Te damos la Bienvenida a Evaluación 360</b>
      <br>
      <i>Recomendaciones</i>
    </p>
    <ol>
      <li>Utilizar computadora personal o laptop</li>
      <li>Buena conexión a Internet</li>
      <li>Evitar distracciones o interrupciones</li>
      <li>Disponer de al menos 15 minutos para resolver</li>
      <li>No interrumpir el proceso o salirse de las pantallas</li>
      <li>Cualquier duda contactar a Recursos Humanos</li>
      <li>Para apoyo o dudas marcar al (664) 123 71 79</li>
    </ol>

    <div class="divider"></div>

    <div class="row">
      <div class="input-field col s12 m6">
        <i class="material-icons prefix">email</i>
        <input id="userEmail" type="email" class="validate" v-model="userEmail" required>
        <label for="userEmail">Correo Electrónico</label>
      </div>
      <div class="input-field col s12 m6">
        <i class="material-icons prefix">lock</i>
        <input id="userCode" type="password" class="validate" v-model="userCode" required>
        <label for="userCode">Código de acceso</label>
      </div>
    </div>

    <div class="right-align">
      <a href="https://www.google.com/" class="btn-flat waves-effect red-text">
        <i class="material-icons left">close</i>
        Salir
      </a>
      <button class="btn waves-effect indigo">
        <i class="material-icons left">send</i>
        Entrar
      </button>
    </div>
  </form>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  computed: {
    ...mapState([])
  },
  data() {
    return {
      userEmail: "",
      userCode: ""
    };
  },
  computed: {
    ...mapState(["thisCampain"])
  },
  methods: {
    verifyUserCode() {
      axios
        .get(
          "https://evaluacion-360.human-express.com/php/questionnaire/login.php?uid=" +
            this.thisCampain.id
        )
        .then(response => {
          if (response.data.status == true) {
			var find = false;

			let evaluators = JSON.parse(response.data.evaluators);
			console.log(evaluators)
			this.updateEvaluators(evaluators);

            evaluators.forEach(evaluator => {
              if (evaluator.email == this.userEmail) {
                find = true;
                if (evaluator.userCode == this.userCode && evaluator.active) {
                  this.updateEvaluator(evaluator);
                  this.$emit("nextStep");
				  M.toast({ html: "Bienvenido" });
				  console.log(evaluator)
                } else {
                  M.toast({
                    html: "No puede acceder a la evaluación en este momento o ya lo realizo"
                  });
                }
              }
            });

            if (!find) {
                M.toast({ html: "Correo o contraseña no coinciden con nuestros registros" });
            }

          }
        });
    },
    ...mapMutations(["updateEvaluator", "updateEvaluators"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireSteps/login.vue